import { STATUSES } from 'constants/statuses';

export const convertedStatusesNames = {
    [STATUSES.ACCEPTED]: 'Accepted',
    [STATUSES.REJECTED]: 'Rejected',
    [STATUSES.ACTIVE]: 'Ongoing',
    [STATUSES.CLOSED]: ' ',
    [STATUSES.NOT_FOUND]: 'n/a',
};
